export const fr = {
  translation: {
    seo: {
      defaults: {
        siteName: 'Fati Caftan',
        description: 'Atelier artisanal marocain — caftans, takchitas, djellabas sur mesure et prêt à porter. Couture traditionnelle, broderies main, finitions soignées.'
      },
      organization: {
        description: 'Atelier de couture traditionnelle marocaine — caftans, takchitas, djellabas et pièces prêtes à porter, confectionnés à la main au Maroc.'
      },
      home: {
        title: 'Caftans & couture traditionnelle marocaine',
        description: 'Découvrez la collection Fati Caftan : caftans, takchitas et djellabas confectionnés à la main au Maroc. Sur mesure ou prêt à porter, prise de rendez-vous en ligne.'
      },
      productDetail: {
        title: 'Détails de la pièce',
        description: 'Pièce artisanale Fati Caftan — confection à la main, broderies traditionnelles. Réservation par WhatsApp ou prise de rendez-vous pour les mesures.'
      },
      about: {
        title: 'À propos de l\'atelier',
        description: 'L\'histoire et le savoir-faire de l\'atelier Fati Caftan, dédié à la couture traditionnelle marocaine.'
      },
      contact: {
        title: 'Contact',
        description: 'Joignez l\'atelier Fati Caftan par email, téléphone ou WhatsApp pour toute question sur les pièces, les rendez-vous ou les réservations.'
      },
      faq: {
        title: 'Questions fréquentes',
        description: 'Tout ce qu\'il faut savoir avant de commander une pièce sur mesure ou de réserver un caftan prêt à porter chez Fati Caftan.'
      },
      terms: {
        title: 'Conditions',
        description: 'Conditions générales applicables à l\'utilisation du site Fati Caftan.'
      },
      legal: {
        title: 'Mentions légales',
        description: 'Mentions légales du site Fati Caftan — éditeur, hébergeur, propriété intellectuelle et contact.'
      },
      cgv: {
        title: 'Conditions de service',
        description: 'Conditions de prise de rendez-vous et de réservation des pièces de l\'atelier Fati Caftan.'
      },
      privacy: {
        title: 'Politique de confidentialité',
        description: 'Protection des données personnelles sur Fati Caftan — conformément à la loi marocaine 09-08 et au RGPD européen.'
      },
      notFound: {
        title: 'Page introuvable',
        description: 'La page demandée n\'existe pas ou a été déplacée.'
      },
      underConstruction: {
        title: 'Bientôt disponible',
        description: 'Le site Fati Caftan finalise sa boutique en ligne. Contactez l\'atelier sur WhatsApp pour en savoir plus.'
      }
    },
    header: {
      title: 'Couture sur Mesure',
      languages: {
        en: 'Anglais',
        fr: 'Français',
        ar: 'Arabe'
      }
    },
    underConstruction: {
      kicker: 'Atelier · Maroc',
      badge: 'Bientôt disponible',
      title: {
        line1: 'Les coutures finales',
        line2: 'sont en cours.'
      },
      subtitle: 'Notre atelier finalise sa boutique en ligne. Caftans, takchitas, djellabas et pièces prêtes à porter — taillées à la main au Maroc. Contactez-nous dès aujourd\'hui sur WhatsApp pour réserver une consultation ou en savoir plus.',
      contactCta: 'Contactez-nous sur WhatsApp',
      contactHint: 'Réponse sous 24 h.',
      expected: {
        label: 'Commandes',
        value: 'Déjà ouvertes sur WhatsApp'
      },
      workshop: {
        label: 'L\'atelier',
        value: 'Pièces uniques cousues main, broderies traditionnelles, sur mesure ou prêt à porter.'
      },
      footer: '© {{year}} Fati Caftan — tous droits réservés.',
      whatsapp: {
        message: 'Bonjour, je viens de votre site faticaftan.com — j\'aimerais en savoir plus sur vos pièces.'
      }
    },
    nav: {
      home: 'Accueil',
      dashboard: 'Tableau de bord',
      appointments: 'Rendez-vous',
      calendar: 'Calendrier',
      products: 'Produits',
      analytics: 'Audience',
      cart: 'Panier',
      login: 'Connexion',
      logout: 'Déconnexion',
      openMenu: 'Ouvrir le menu',
      closeMenu: 'Fermer le menu'
    },
    adminAnalytics: {
      title: 'Audience',
      subtitle: 'Fréquentation du site, mesurée depuis les journaux du serveur. Aucun script de suivi, aucun cookie.',
      loading: 'Chargement des chiffres…',
      visitors: 'Visiteurs uniques',
      pageViews: 'Pages vues',
      period: 'Période',
      dailyRefresh: 'Mis à jour une fois par jour',
      daily: 'Visites par jour',
      dailyChartLabel: 'Graphique des visites par jour',
      noDaily: 'Pas encore de série journalière.',
      topPages: 'Pages les plus vues',
      referrers: 'Provenance',
      countries: 'Pays',
      noData: 'Aucune donnée.',
      noCountries: 'Base pays absente — relancer le script avec ACTION=geoip.',
      unavailableMock: 'Chiffres indisponibles en mode démo : aucune donnée réelle à afficher.',
      botNote: 'Les robots déclarés, la surveillance de disponibilité et les sondes de scan sont exclus. Un résidu de trafic automatisé subsiste sur la page d’accueil.'
    },
    calendar: {
      title: 'Calendrier',
      subtitle: 'Vue mensuelle des rendez-vous.',
      prev: 'Mois précédent',
      next: 'Mois suivant',
      today: 'Aujourd\'hui',
      more: 'autre(s)'
    },
    dashboard: {
      title: 'Tableau de bord',
      subtitle: 'Vue d\'ensemble des rendez-vous et du catalogue.',
      viewAll: 'Voir tout',
      stats: {
        pending: 'En attente',
        confirmed: 'Confirmés',
        completed: 'Terminés',
        cancelled: 'Annulés',
        products: 'Produits'
      },
      upcoming: {
        title: 'À venir (7 prochains jours)',
        empty: 'Aucun rendez-vous dans les 7 jours.'
      },
      recent: {
        title: 'Demandes récentes',
        empty: 'Aucune demande pour le moment.'
      }
    },
    confirm: {
      confirm: 'Confirmer',
      cancel: 'Annuler'
    },
    login: {
      title: 'Connexion Admin',
      email: 'Email',
      password: 'Mot de passe',
      submit: 'Se connecter',
      submitting: 'Connexion…',
      mockHint: {
        title: 'Identifiants de test (dev seulement)'
      }
    },
    hero: {
      title: 'Excellence sur Mesure',
      subtitle: 'Prenez rendez-vous dès aujourd\'hui pour vos mesures professionnelles. Nos tailleurs experts garantissent un ajustement parfait et une qualité exceptionnelle pour vos vêtements sur mesure.',
      kicker: 'Maison de Couture — Maroc',
      titleLine1: 'La nuit comme',
      titleAccent1: 'écrin',
      titleLine2: ', le caftan',
      titleLine3: 'comme',
      titleAccent2: 'signature.',
      lede: 'Quinze années d\'atelier au Maroc. Soie, brocart, broderies au fil d\'or. Chaque pièce existe à un seul exemplaire — la vôtre, parce que nous la cousons après vous avoir rencontrée.',
      ctaPrimary: 'Prendre rendez-vous',
      ctaSecondary: 'Découvrir les collections',
      refNumber: 'N°00',
      refLabel: 'Numéro inaugural'
    },
    atelier: {
      kicker: 'N° 05 — L\'Atelier',
      titleLine1: 'Une',
      titleAccent: 'maison',
      titleLine2: ', une signature.',
      body1: 'Fati a appris la couture aux côtés de sa mère, dans une maison de la médina de Fès, à un âge où d\'autres jouaient encore. Quinze ans plus tard, elle dessine chaque pièce à l\'encre brune sur du papier kraft, choisit ses tissus à Bab Boujloud, et confie les broderies à un cercle d\'artisanes qu\'elle connaît par leur prénom.',
      body2: 'Chaque caftan suit un calendrier de huit semaines minimum. Pas de stock, pas de production de masse. Le luxe, ici, c\'est le temps qu\'on prend pour vous.',
      stats: {
        yearsValue: '15',
        yearsLabel: 'Années atelier',
        piecesValue: '200+',
        piecesLabel: 'Pièces livrées',
        citiesValue: '2',
        citiesLabel: 'Casa · Marrakech'
      }
    },
    waStrip: {
      titleLine1: 'Une',
      titleAccent: 'question',
      titleLine2: ', une commande sur mesure ?',
      subtitle: 'Whatsappez l\'atelier — réponse sous 24 h, en français, en arabe, en anglais.',
      cta: 'Écrire à l\'atelier'
    },
    share: {
      button: 'Partager',
      copiedToast: 'Lien copié',
      copyFailed: 'Impossible de copier le lien.',
      instagramHint: 'Lien copié — collez-le dans votre story Instagram',
      targets: {
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        pinterest: 'Pinterest',
        instagram: 'Instagram (copier)',
        email: 'Email',
        copy: 'Copier le lien'
      }
    },
    story: {
      button: 'Format story Instagram',
      generating: 'Génération…',
      success: 'Image story téléchargée — postez-la sur votre story.',
      error: 'Impossible de générer l\'image story'
    },
    currency: {
      label: 'Devise',
      indicative: '≈ prix indicatif',
      codes: {
        MAD: 'Dirham (MAD)',
        EUR: 'Euro (EUR)',
        USD: 'Dollar (USD)'
      }
    },
    product: {
      duration: 'Durée des Mesures',
      viewDetails: 'Voir les Détails',
      scheduleButton: 'Prendre Rendez-vous pour les Mesures',
      shopButton: 'Commander',
      reserveButton: 'Réserver',
      readyToWearBadge: 'Prêt à porter'
    },
    cart: {
      title: 'Mon panier',
      itemCount: '{{count}} article(s) dans le panier',
      sizeLabel: 'Taille',
      increase: 'Augmenter la quantité',
      decrease: 'Diminuer la quantité',
      remove: 'Retirer',
      checkoutCta: 'Passer la commande',
      continueShopping: 'Continuer mes achats',
      empty: {
        title: 'Votre panier est vide',
        description: 'Découvrez nos pièces prêtes à porter et ajoutez-les ici.',
        cta: 'Voir le catalogue'
      },
      summary: {
        title: 'Récapitulatif',
        subtotal: 'Sous-total',
        shipping: 'Livraison',
        shippingHint: 'À confirmer sur WhatsApp',
        total: 'Total'
      },
      toast: {
        added: 'Ajouté au panier (taille {{size}})'
      }
    },
    checkout: {
      title: 'Finaliser la commande',
      subtitle: 'Vos coordonnées seront transmises à la couturière sur WhatsApp pour confirmer le stock et organiser la livraison.',
      backToCart: 'Retour au panier',
      submitCta: 'Envoyer sur WhatsApp',
      success: 'Commande envoyée — la couturière va vous répondre.',
      disclaimer: 'Le paiement et la livraison sont organisés directement avec la couturière par WhatsApp.',
      fields: {
        fullName: 'Nom complet',
        phone: 'Téléphone',
        city: 'Ville',
        address: 'Adresse de livraison',
        notes: 'Note (optionnel)'
      },
      errors: {
        required: 'Champ requis',
        invalidPhone: 'Numéro invalide'
      },
      whatsapp: {
        header: 'Bonjour, je souhaite passer la commande suivante :',
        itemsHeader: 'Articles :',
        total: 'Total',
        footer: 'Merci de me confirmer le stock et le mode de livraison.'
      }
    },
    form: {
      title: 'Planifier un Rendez-vous de Mesure',
      about: {
        title: 'À Propos du Processus de Mesure',
        description: 'Notre service de mesure professionnel garantit un ajustement parfait et une personnalisation. Un spécialiste qualifié prendra des mesures détaillées à l\'aide d\'outils de pointe.',
        duration: 'Durée'
      },
      fields: {
        name: 'Nom Complet',
        email: 'Email',
        phone: 'Numéro de Téléphone',
        date: 'Date Préférée',
        time: 'Horaire Préféré',
        notes: 'Exigences Particulières ou Notes',
        notesPlaceholder: 'Toute exigence particulière ou information supplémentaire...'
      },
      timeSlots: {
        morning: 'Matin',
        afternoon: 'Après-midi',
        evening: 'Soir'
      },
      buttons: {
        cancel: 'Annuler',
        confirm: 'Confirmer le Rendez-vous'
      },
      success: 'Rendez-vous programmé avec succès ! Vous recevrez bientôt un email de confirmation.',
      errors: {
        nameTooShort: 'Veuillez saisir votre nom complet (au moins 2 caractères).',
        emailInvalid: 'Veuillez saisir une adresse email valide.',
        phoneInvalid: 'Veuillez saisir un numéro de téléphone valide.',
        dateRequired: 'Veuillez choisir une date.',
        timeRequired: 'Veuillez choisir un créneau.',
        slotConflict: 'Ce créneau vient d\'être réservé. Veuillez en choisir un autre.'
      },
      slots: {
        fullyBooked: 'complet',
        taken: 'pris'
      }
    },
    catalog: {
      search: {
        label: 'Rechercher dans le catalogue',
        placeholder: 'Rechercher par nom ou description…'
      },
      category: {
        label: 'Catégorie',
        values: {
          ALL: 'Tout',
          CAFTAN: 'Caftan',
          TAKCHITA: 'Takchita',
          DJELLABA: 'Djellaba',
          OTHER: 'Autre'
        }
      },
      type: {
        label: 'Mode d\'achat',
        values: {
          ALL: 'Tout',
          CUSTOM: 'Sur mesure',
          READY_TO_WEAR: 'Prêt à porter'
        }
      },
      minPrice: 'Prix min',
      maxPrice: 'Prix max',
      sort: {
        label: 'Trier par',
        relevance: 'Pertinence',
        priceAsc: 'Prix : croissant',
        priceDesc: 'Prix : décroissant',
        ratingDesc: 'Mieux notés'
      },
      clear: 'Effacer',
      empty: 'Aucun produit ne correspond à vos filtres.',
      count: '{{count}} produit(s) sur {{total}}',
      sections: {
        emptyCategory: 'Aucune pièce disponible dans cette catégorie pour le moment.',
        caftan: {
          num: '01',
          numLabel: 'Catégorie',
          titleLine1: 'Les',
          titleAccent: 'caftans',
          titleLine2: '.',
          subtitle: 'Pièces sur mesure pour mariées et grandes occasions.',
          countLabel: 'pièces · sur mesure',
          metaLine1: 'Sur mesure · 8 semaines',
          metaLine2: '3 essayages'
        },
        takchita: {
          num: '02',
          numLabel: 'Catégorie',
          titleLine1: 'Les',
          titleAccent: 'takchitas',
          titleLine2: '.',
          subtitle: 'Deux pièces, deux temps. Pour les grandes soirées.',
          countLabel: 'pièces · sur mesure',
          metaLine1: 'Sur mesure · 10 semaines',
          metaLine2: 'Avec ceinture or'
        },
        djellaba: {
          num: '03',
          numLabel: 'Catégorie',
          titleLine1: 'Les',
          titleAccent: 'djellabas',
          titleLine2: '.',
          subtitle: 'Quotidien raffiné, prêtes à porter ou cousues main.',
          countLabel: 'pièces · sur mesure',
          metaLine1: 'Prêt à porter · stock',
          metaLine2: 'Sur mesure · 4 semaines'
        },
        readyToWear: {
          num: '04',
          numLabel: 'Catégorie',
          titleLine1: 'Le',
          titleAccent: 'prêt-à-porter',
          titleLine2: '.',
          subtitle: 'Pièces disponibles immédiatement, tailles XS à XXL.',
          countLabel: 'pièces · stock',
          metaLine1: 'Livraison · 7 jours',
          metaLine2: 'Échange sous 14 jours'
        }
      },
      scrollPrev: 'Précédent',
      scrollNext: 'Suivant'
    },
    whatsapp: {
      aria: 'Contacter sur WhatsApp',
      message: 'Bonjour, je souhaiterais en savoir plus sur vos pièces sur mesure.'
    },
    testimonials: {
      kicker: '— Témoignages',
      title: 'Confidences d\'atelier',
      subtitle: 'Ce que disent celles qui ont déjà porté nos pièces.',
      items: {
        one: {
          name: 'Yasmine A.',
          city: 'Casablanca',
          quote: 'Une coupe parfaite pour mon mariage. Chaque détail a été travaillé à la main avec une patience rare.'
        },
        two: {
          name: 'Salma B.',
          city: 'Rabat',
          quote: 'L\'écoute et le sens du détail m\'ont conquise. Mon caftan tombait comme une seconde peau.'
        },
        three: {
          name: 'Nora E.',
          city: 'Marrakech',
          quote: 'Service d\'exception, du premier essayage à la livraison. Je recommande sans hésiter.'
        },
        four: {
          name: 'Inès D.',
          city: 'Paris',
          quote: 'Une pièce vraiment unique pour un mariage à Fès. Le rendu dépasse mes attentes.'
        }
      }
    },
    notFound: {
      kicker: 'Erreur · 404',
      titleLine1: 'Cette page',
      titleLine2: 's\'est égarée.',
      subtitle: 'Le lien que vous avez suivi est peut-être obsolète, ou la pièce que vous cherchez a quitté l\'atelier. Reprenons depuis le commencement.',
      requestedPath: 'Adresse demandée',
      backHome: 'Retour à l\'accueil',
      suggestions: {
        catalog: 'Parcourir le catalogue',
        about: 'Découvrir l\'atelier',
        contact: 'Nous contacter'
      }
    },
    productDetail: {
      back: 'Retour au catalogue',
      gallery: 'Galerie',
      thumbnailAlt: 'Vue {{n}} de {{title}}',
      from: 'À partir de',
      rating: 'Note',
      durationLabel: 'Durée des mesures',
      detailsTitle: 'Détails de la pièce',
      reserveCta: 'Prendre rendez-vous pour mes mesures',
      sizeLabel: 'Taille',
      addToCart: 'Ajouter au panier',
      buyNow: 'Acheter maintenant',
      reserveOnWhatsApp: 'Réserver via WhatsApp',
      reserveOnWhatsAppHint: 'Échange direct — paiement en présentiel ou par virement.',
      reserveWhatsAppMessage: 'Bonjour, je souhaite réserver « {{title}} » en taille {{size}} ({{price}} MAD). Est-elle disponible ?',
      outOfStock: 'Rupture de stock',
      notFound: 'Produit introuvable.',
      loading: 'Chargement…'
    },
    footer: {
      tagline: 'Vêtements sur mesure, taillés à la main à Paris depuis 2014.',
      explore: 'Explorer',
      contact: 'Contact',
      hours: 'Horaires',
      weekdays: 'Lun – Ven : 10h00 – 19h00',
      saturday: 'Samedi : 11h00 – 18h00',
      sunday: 'Dimanche : fermé',
      rights: 'Tous droits réservés.',
      links: {
        about: 'À propos',
        contact: 'Contact',
        terms: 'Conditions',
        cgv: 'Conditions de service',
        privacy: 'Confidentialité',
        legal: 'Mentions légales',
        faq: 'FAQ'
      }
    },
    faq: {
      kicker: 'Questions fréquentes',
      titleLine1: 'Tout ce qu\'il faut savoir',
      titleLine2: 'avant votre rendez-vous.',
      subtitle: 'Réponses aux questions les plus courantes sur nos pièces, mesures et délais.',
      cta: {
        lead: 'Une question qui ne figure pas ici ?',
        button: 'Écrivez-nous'
      },
      items: {
        appointment: {
          question: 'Comment prendre rendez-vous pour mes mesures ?',
          answer: 'Choisissez la pièce qui vous intéresse dans le catalogue puis cliquez sur « Prendre rendez-vous ». Sélectionnez date et créneau (matin, après-midi ou soir). Vous recevrez une confirmation par email dans les 24 h.'
        },
        measurement: {
          question: 'La séance de mesures, comment ça se passe ?',
          answer: 'Une artisane qualifiée prend une vingtaine de mesures précises avec des outils professionnels. Elle vous conseille également sur les tissus, coupes et finitions adaptés à votre morphologie et à l\'occasion.'
        },
        duration: {
          question: 'Combien de temps pour recevoir ma pièce ?',
          answer: 'Comptez 4 à 6 semaines pour un caftan ou une takchita complète, 2 à 3 semaines pour une djellaba ou une pièce plus simple. Pour les mariages, prévoyez 8 semaines minimum afin d\'inclure plusieurs essayages.'
        },
        fabric: {
          question: 'Puis-je choisir mon tissu ?',
          answer: 'Oui. Nous travaillons des soies, mousselines, brocarts et lainages sélectionnés auprès de fournisseurs marocains et européens. Vous pouvez également apporter votre propre tissu — nous vous conseillerons sur sa compatibilité avec le modèle souhaité.'
        },
        fitting: {
          question: 'Combien d\'essayages sont prévus ?',
          answer: 'Deux essayages intermédiaires sont inclus dans le tarif, plus un essayage final à la livraison. Pour les pièces complexes (caftan de mariée par exemple), un troisième essayage peut être ajouté sans supplément.'
        },
        alteration: {
          question: 'Les retouches sont-elles incluses ?',
          answer: 'Toutes les retouches d\'ajustement sont incluses pendant la première année. Au-delà, les retouches restent possibles à un tarif préférentiel pour nos clientes.'
        },
        payment: {
          question: 'Quels sont les modes de paiement ?',
          answer: 'Un acompte de 50 % valide la commande à l\'issue de la séance de mesures. Le solde est réglé à la livraison. Nous acceptons carte bancaire, virement et espèces.'
        },
        cancellation: {
          question: 'Puis-je annuler ou modifier mon rendez-vous ?',
          answer: 'Annulation ou modification gratuite jusqu\'à 24 h avant le rendez-vous, depuis le lien dans votre email de confirmation. Au-delà, un nouveau créneau peut être proposé selon disponibilités.'
        },
        travel: {
          question: 'Vous déplacez-vous à domicile ?',
          answer: 'Pour les mariages et grandes commandes (à partir de 3 pièces), nous nous déplaçons à domicile dans Casablanca, Rabat et Marrakech sans supplément. Au-delà, des frais de déplacement peuvent s\'appliquer.'
        },
        delivery: {
          question: 'Livrez-vous à l\'international ?',
          answer: 'Oui, nous expédions partout dans le monde via transporteur assuré. Les frais et délais varient selon la destination ; ils vous seront communiqués lors de la commande.'
        }
      }
    },
    about: {
      title: 'À propos',
      lead: 'Un petit atelier parisien dédié à l\'artisanat sur mesure.',
      body1: 'Nous taillons des vêtements à la main depuis 2014, à partir de tissus soigneusement choisis chez les meilleurs fabricants italiens et anglais. Chaque pièce est coupée, cousue et finie dans notre atelier — sans sous-traitance, sans production de masse.',
      body2: 'Que ce soit pour un mariage, un quotidien professionnel ou une grande occasion, nous prenons les mesures en personne et adaptons chaque détail à votre posture, vos gestes et votre mode de vie.',
      valuesTitle: 'Nos valeurs',
      values: {
        craft: {
          title: 'Artisanat à la main',
          body: 'Chaque couture, boutonnière et doublure est réalisée par des tailleurs expérimentés selon les techniques traditionnelles.'
        },
        quality: {
          title: 'Qualité des matières',
          body: 'Nous travaillons avec des tisseurs de longue date et refusons les raccourcis qui compromettraient le tombé ou la durabilité.'
        },
        service: {
          title: 'Service personnel',
          body: 'Moins de clients, plus d\'attention. Chaque essayage est pris au sérieux et les retouches sont incluses à vie.'
        }
      }
    },
    contact: {
      title: 'Contact',
      lead: 'Questions, demandes sur mesure ou collaborations — nous lisons chaque message.',
      email: 'Email',
      phone: 'Téléphone',
      address: 'Atelier',
      fields: {
        name: 'Votre nom',
        email: 'Email',
        message: 'Message'
      },
      sending: 'Envoi…',
      send: 'Envoyer',
      success: 'Merci ! Nous vous répondrons sous un jour ouvré.'
    },
    terms: {
      title: 'Conditions générales',
      updated: 'Dernière mise à jour : {{date}}',
      sections: {
        scope: {
          title: '1. Objet',
          body: 'Ces conditions régissent les réservations effectuées via notre site et le service sur mesure proposé dans notre atelier parisien.'
        },
        appointments: {
          title: '2. Rendez-vous',
          body: 'Les rendez-vous sont confirmés par email. Merci d\'arriver 5 minutes en avance et d\'apporter toute pièce de référence souhaitée.'
        },
        payment: {
          title: '3. Paiement',
          body: 'Un acompte de 50 % confirme votre commande sur mesure. Le solde est réglé à la livraison. Nous acceptons carte bancaire et virement.'
        },
        cancellation: {
          title: '4. Annulation',
          body: 'Annulation gratuite jusqu\'à 24 h avant le rendez-vous. Les commandes sur mesure, une fois coupées, ne sont pas remboursables — mais les retouches sont incluses à vie.'
        },
        privacy: {
          title: '5. Confidentialité',
          body: 'Nous collectons uniquement les informations nécessaires au service. Vos données ne sont ni vendues ni partagées. Vous pouvez demander leur suppression à tout moment.'
        },
        liability: {
          title: '6. Responsabilité',
          body: 'Nous garantissons notre artisanat. En cas de défaut dans les douze mois suivant la livraison, nous réparons ou remplaçons sans frais.'
        }
      }
    },
    admin: {
      title: 'Rendez-vous',
      subtitle: 'Consultez et gérez les demandes de rendez-vous de mesure.',
      empty: 'Aucun rendez-vous ne correspond à ce filtre.',
      confirmDelete: {
        title: 'Supprimer le rendez-vous ?',
        message: 'Ce rendez-vous sera définitivement supprimé. Cette action est irréversible.'
      },
      toast: {
        statusUpdated: 'Statut du rendez-vous mis à jour.',
        deleted: 'Rendez-vous supprimé.'
      },
      filter: {
        all: 'Tous',
        pending: 'En attente',
        confirmed: 'Confirmés',
        completed: 'Terminés',
        cancelled: 'Annulés'
      },
      status: {
        pending: 'En attente',
        confirmed: 'Confirmé',
        completed: 'Terminé',
        cancelled: 'Annulé'
      },
      table: {
        client: 'Client',
        product: 'Produit',
        date: 'Date',
        requested: 'Demandé le',
        status: 'Statut',
        actions: 'Actions'
      },
      actions: {
        confirm: 'Confirmer',
        complete: 'Marquer terminé',
        reopen: 'Remettre en attente',
        cancel: 'Annuler',
        delete: 'Supprimer'
      },
      search: {
        label: 'Rechercher',
        placeholder: 'Nom, email, téléphone…',
        from: 'Du',
        to: 'Au',
        clear: 'Effacer les filtres'
      },
      pagination: {
        showing: '{{from}}–{{to}} sur {{total}}'
      },
      detail: {
        title: 'Rendez-vous',
        client: 'Client',
        booking: 'Réservation',
        notes: 'Notes',
        notesPlaceholder: 'Ajouter des notes internes…',
        saveNotes: 'Enregistrer les notes',
        saving: 'Enregistrement…',
        notesSaved: 'Notes enregistrées.',
        timeline: 'Historique',
        created: 'Créé',
        updated: 'Dernière maj',
        actions: 'Actions'
      }
    },
    adminProducts: {
      title: 'Produits',
      subtitle: 'Créez, modifiez et supprimez les articles du catalogue public.',
      new: 'Nouveau produit',
      empty: 'Aucun produit. Créez le premier.',
      i18n: {
        sourceLocaleLabel: 'Langue de saisie',
        sourceLocaleHint: 'Langue du titre et de la description ci-dessous (ce que vous tapez).',
        locales: {
          ar: 'Arabe',
          fr: 'Français',
          en: 'Anglais'
        },
        translationsLabel: 'Traductions',
        translationsHint: 'Générées par IA depuis la source, puis révisez avant d\'enregistrer.',
        translateButton: 'Traduire (IA)',
        translating: 'Traduction…',
        translated: 'Traduction terminée ({{count}} langues) — relisez avant d\'enregistrer.',
        errors: {
          needSource: 'Saisissez d\'abord le titre et la description source.',
          empty: 'Le service de traduction n\'a rien renvoyé. Réessayez, ou saisissez les traductions à la main.'
        }
      },
      confirmDelete: {
        title: 'Supprimer le produit ?',
        message: 'Supprimer « {{title}} » ? Il disparaîtra du catalogue public.'
      },
      toast: {
        created: 'Produit créé.',
        updated: 'Produit mis à jour.',
        deleted: 'Produit supprimé.'
      },
      table: {
        product: 'Produit',
        price: 'Prix',
        duration: 'Durée',
        rating: 'Note',
        actions: 'Actions'
      },
      actions: {
        edit: 'Modifier',
        delete: 'Supprimer'
      },
      fields: {
        title: 'Titre',
        category: 'Catégorie',
        productType: 'Mode d\'achat',
        productTypeHint: 'Sur mesure : prise de rendez-vous. Prêt à porter : panier + livraison.',
        price: 'Prix',
        originalPrice: 'Prix d\'origine (optionnel)',
        description: 'Description',
        image: 'Image',
        imageUrl: 'URL de l\'image',
        rating: 'Note (0–5)',
        measurementDuration: 'Durée de mesure'
      },
      variants: {
        label: 'Tailles et stock',
        sizeLabel: 'Taille',
        stockLabel: 'Stock',
        stockSuffix: 'pièce(s)',
        remove: 'Retirer cette taille',
        hint: 'Une ligne par taille. Cliquez sur une taille pour l\'ajouter, puis renseignez le stock.',
        errors: {
          required: 'Ajoutez au moins une taille (mode prêt à porter).',
          invalidRow: 'Vérifiez les tailles et stocks (stock ≥ 0).'
        }
      },
      image: {
        dropOrClick: 'Glissez une image ou cliquez pour téléverser',
        hint: 'PNG, JPG ou WEBP, max 10 Mo. Une URL est aussi acceptée ci-dessous.',
        urlPlaceholder: 'ou collez une URL d\'image…',
        sourceLabel: 'Photo source',
        sourceHint: 'La photo d\'origine ayant servi à générer les visuels. Non visible par les clients.',
        regenerateFromSource: 'Régénérer depuis la source',
        zoom: 'Agrandir l’image',
        zoomClose: 'Fermer l’aperçu',
        primaryHint: 'image principale (vitrine catalogue)',
        errors: {
          notImage: 'Le fichier sélectionné n\'est pas une image.',
          tooLarge: 'Image trop volumineuse (max 10 Mo).',
          required: 'Veuillez ajouter une image (fichier ou URL).'
        }
      },
      gallery: {
        label: 'Galerie',
        add: 'Ajouter',
        remove: 'Retirer',
        reorder: 'Glisser pour réorganiser',
        setAsPrimary: 'Définir comme image principale',
        imageAlt: 'Image {{n}} de la galerie',
        hint: 'Images secondaires affichées sur la page détail du produit. Jusqu\'à 8 images. Glissez la poignée pour réorganiser — la 1ère sert d\'image principale de la galerie.',
        errors: {
          full: 'Galerie pleine (max {{max}} images). Retirez-en une pour en ajouter.'
        }
      },
      form: {
        newTitle: 'Nouveau produit',
        editTitle: 'Modifier le produit',
        cancel: 'Annuler',
        save: 'Enregistrer',
        saving: 'Enregistrement…'
      },
      ai: {
        button: 'Améliorer avec IA',
        buttonHint: 'Génère 4 poses sur modèle humaine (≈1 min, ≈$0,16 la série).',
        title: 'Améliorer la photo avec IA',
        intro: 'L\'IA va remplacer le mannequin par une silhouette humaine réaliste et un fond studio propre, en conservant chaque détail de broderie du vêtement.',
        introSet: 'L\'IA va générer 4 poses différentes à partir de la photo source. Gardez celles qui vous plaisent, rejetez ou régénérez les autres.',
        setHint1: 'Chaque pose met en valeur un angle différent du vêtement (face debout, assise, dos, marche de profil).',
        setHint2: 'Coût : ≈$0,16 pour la série de 4, ≈$0,04 par régénération.',
        keptCount_zero: 'Aucune pose conservée',
        keptCount_one: '{{count}} pose conservée',
        keptCount_other: '{{count}} poses conservées',
        originalLabel: 'Photo originale',
        transformedLabel: 'Résultat IA',
        placeholder: 'En attente…',
        startCta: 'Lancer la transformation',
        startSetCta: 'Générer 4 poses',
        startNewSet: 'Nouveau jeu de 4',
        startSetCostHint: 'Génère 4 nouvelles poses (~0,16 $). Les images déjà gardées ne sont pas supprimées.',
        resuming: 'Chargement des poses existantes…',
        finishCta_zero: 'Terminer',
        finishCta_one: 'Terminer ({{count}} pose)',
        finishCta_other: 'Terminer ({{count}} poses)',
        processing: 'Génération…',
        processingHint: 'Peut prendre 15 à 30 secondes.',
        working: 'Traitement…',
        failed: 'Échec.',
        rejected: 'Rejetée.',
        accept: 'Accepter',
        keep: 'Garder',
        kept: 'Gardée',
        keptBadge: 'Gardée',
        reject: 'Rejeter',
        regenerate: 'Régénérer',
        regenerateCostHint: 'Régénérer coûte ~0,04 $.',
        promptEdit: 'Modifier le prompt',
        promptHide: 'Masquer le prompt',
        promptRegenerate: 'Régénérer avec ce prompt',
        promptReset: 'Rétablir',
        retry: 'Réessayer',
        cancel: 'Annuler',
        close: 'Fermer',
        poses: {
          STANDING_FRONT: 'Debout face',
          SEATED: 'Assise',
          BACK_OVER_SHOULDER: 'Dos / regard',
          WALKING_SIDE: 'Marche profil'
        },
        errors: {
          pollTimeout: 'Délai dépassé — la génération a pris trop de temps. Réessayez ou contactez l\'admin si le problème persiste.'
        }
      }
    }
  }
};
